import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../api.service';
import * as CryptoJS from 'crypto-js';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'dhhp-dialog-overview-confirmation',
  templateUrl: './dialog-overview-confirmation.component.html',
  styleUrls: ['./dialog-overview-confirmation.component.css']
})
export class DialogOverviewComponent implements OnInit {
  confirmData: any;
  onlyDelete=false;
  profileModify=false;
  notDelProfile=false;
  consentConfirm=false;
  hide = true;
  submitted:boolean=false;
  username;
  @ViewChild('passwordModel') passwordModel;
  email;
  authPassword;
  modifyData:any;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<DialogOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if(this.confirmData.delUser == true){
      this.onlyDelete = true;
      this.notDelProfile = false;
      this.profileModify = false;
      this.email = this.confirmData.delData.email;
    }
    if(this.confirmData.profileUpdate == true){
      this.profileModify = true;
      this.notDelProfile = false;
      this.onlyDelete = false;
    } 
    if(this.confirmData.changePass == true){
      this.profileModify = false;
      this.notDelProfile = true;
      this.onlyDelete = false;
    }
    if(this.confirmData.privacyConfirm == true){
      this.profileModify = false;
      this.notDelProfile = false;
      this.onlyDelete = false;
      this.consentConfirm = true;
    }
  }

  onCloseDialog () : void  {
    this.submitted = false;
    this.dialogRef.close({ event: 'cancel' });
  }
  onClose(event) {
    event.preventDefault();
    this.dialogRef.close({ event: 'confirm' });
  }
  encryptUsingAES256(data:any) {
    let _key = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
  onModify(){
    this.submitted = true;
    if (this.passwordModel.invalid) {
      return false;
    }
    // const formDetails = {
    //   password:this.encryptUsingAES256(this.authPassword)
    // }
    // this.apiService.profileEditAuth(formDetails).subscribe({
    //   next: (data: any) => {
    //    this.dialogRef.close({ event: 'profileMoify' });
    //   },
    //   error: err => {
    //     this.dialogRef.close({ event: 'profileMoifyError' , message:err.error.message});
    //    },
    //   complete: () => { }
    // })
    const formDetails = {
      password:this.authPassword,
      username: this.username
    }
    this.apiService.mhsprofileEditAuth(formDetails).subscribe({
      next: (data: any) => {
       if(data){
        this.dialogRef.close({ event: 'profileMoify' });
       } else {
        this.dialogRef.close({ event: 'profileMoifyError' ,  message:'Invalid password'});
       }
       
      },
      error: err => {
        this.dialogRef.close({ event: 'profileMoifyError' , message:err.message});
       },
      complete: () => { }
    })
  }
  onConfirmDelete() {
    this.dialogRef.close({ event: 'confirmDelete' });
  }
  onCloseDialogConsern(){
    this.submitted = false;
    this.dialogRef.close({ event: 'cancelConsern' });
  }
  onConsernUpdate(){
    const formData = {
      isConsentAgreed:false,
      userId:this.confirmData.userId
    }
    this.apiService.updateConsent(formData).subscribe({
      next: (data: any) => {
        if(data){
          this.dialogRef.close({ event: 'consentModify' });
        }
      },
      error: err => {
        //this.dialogRef.close({ event: 'profileMoifyError' , message:err.error.message});
       },
      complete: () => { }
    })
  }
}
